import { render } from "./ChatDialog.vue?vue&type=template&id=205c4468&scoped=true"
import script from "./ChatDialog.vue?vue&type=script&lang=js"
export * from "./ChatDialog.vue?vue&type=script&lang=js"

import "./ChatDialog.vue?vue&type=style&index=0&id=205c4468&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205c4468"]])

export default __exports__